import { UserRoleEnum } from '../../..';

export class UpdateUserRoleRequestDto {
  userRole: UserRoleEnum;
}
